module.exports = __webpack_public_path__ + "static/img/mapa.f8b0ceb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/representantes/mapa.png
// module id = aemY
// module chunks = 0